import { PromocodesPageDictionary } from 'types/i18n';

export const promocodesPageDictionaryRu: PromocodesPageDictionary = {
  titleText: 'Промокоды',
  editPromocodePasswordActionText: 'Пароль для сайта',
  generatePromocodeActionText: 'Сгенерировать промокод',
  searchInputPlaceholderText: 'Поиск по номеру промокода',
};
